//https://stackoverflow.com/a/1026087/9007975
export function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}
